import { FormControl, IconButton, InputBase, Paper, Tooltip } from "@mui/material";
import { RestartAlt, Search } from "@mui/icons-material";
import { Controller } from "react-hook-form";

const COMMAND_KEY_ENTER = "Enter";
const COMMAND_KEYCODE_ENTER = 13;

import type { Control } from "react-hook-form";
import type { TFunction } from "i18next";

/** Forma del formulario que este input controla: un unico campo `search`. */
export interface SearchFormValues {
  search: string;
}

export interface SearchInputProps {
  control: Control<SearchFormValues>;
  onSearch: () => void;
  onResetSearch: () => void;
  t: TFunction;
}

export const SearchInput = ({ control, onSearch, onResetSearch, t }: SearchInputProps) => {
  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === COMMAND_KEY_ENTER || event.keyCode === COMMAND_KEYCODE_ENTER) {
      event.preventDefault();
      onSearch();
    }
  };

  return (
    <Paper
      component="form"
      sx={{ p: "2px 4px", display: "flex", alignItems: "center", width: "100%" }}
      onSubmit={(event) => {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }}
    >
      <Tooltip title={t("reset")}>
        <IconButton sx={{ p: "10px" }} aria-label="menu" type="button" onClick={onResetSearch}>
          <RestartAlt />
        </IconButton>
      </Tooltip>
      <Controller
        name="search"
        control={control}
        defaultValue=""
        render={({ field }) => (
          <FormControl fullWidth>
            <InputBase
              {...field}
              sx={{ ml: 1, flex: 1 }}
              placeholder={t("searchByVacancies")}
              // InputBase conserva `inputProps`: MUI 9 lo removio de TextField, no de aca.
              // El PR #743 lo migro a slotProps.htmlInput por error, y ese slot no existe en
              // InputBase, con lo cual el aria-label dejaba de llegar. Revertido.
              inputProps={{ "aria-label": "search google maps" }}
              onKeyDown={handleKeyPress}
            />
          </FormControl>
        )}
      />
      <Tooltip title={t("search")}>
        <IconButton type="button" sx={{ p: "10px" }} aria-label="search" onClick={onSearch}>
          <Search />
        </IconButton>
      </Tooltip>
    </Paper>
  );
};
